// import * as moment from 'moment';
import moment from 'moment'

export class DateUtil {

    static getMonthRangeDates(year: number, month: number, format: string) {
        const startDate = moment([year, month - 1]).format(format);
        const endDate = moment(startDate).endOf('month').format(format);
        return { start: startDate, end: endDate };
    }

    static getDaysByMonthArray(start_date: string, end_date: string, format: string) {
        const dates = [];
        let currentDate = new Date(start_date);
        const addDays = function (days) {
            const date = new Date();
            date.setDate(date.getDate() + days);
            return date;
        };
        while (currentDate <= new Date(end_date)) {
            currentDate = addDays.call(currentDate, 1);
            dates.push(moment(currentDate).format(format));
        }
        return dates;
    }

    static getActualDate(format: string) {
        return moment().format(format);
    }

    static getFormattedDate(date: Date, format: string) {
        if (!date) {
            return null;
        }
        return moment(date).format(format);
    }

}
